module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtThree.d800ac5.png";